t = require('app/scripts/views/internal/teacup-with-helpers')('quick_card_editor')
cardTemplate = require 'app/scripts/views/templates/card_in_list'

module.exports = ->
  templateModeEnabled = t.mustacheVar('templateModeEnabled')
  isCardTemplate = t.mustacheVar('isCardTemplate')

  t.span '.icon-lg.icon-close.quick-card-editor-close-icon.js-close-editor'

  t.div '.quick-card-editor-card', { style: 'top: ' + t.mustacheVar('top') + 'px; left: ' + t.mustacheVar('left') + 'px; width: ' + t.mustacheVar('width') + 'px;' }, ->

    t.div '.list-card.list-card-quick-edit.js-stop', { style: 'width: ' + t.mustacheVar('width') + 'px;' }, ->
      cardTemplate t.mustacheVar('.')

    t.input '.primary.wide.js-save-edits', { type: 'submit', value: t.l('save') }

    t.div { class: 'quick-card-editor-buttons' + t.mustacheBlock('leftButtons', (-> ' quick-card-editor-buttons-left')) }, ->
      t.a '.quick-card-editor-buttons-item.js-edit-labels', { href: '#' }, ->
        t.icon 'label', { class: 'light' }
        t.span '.quick-card-editor-buttons-item-text', ->
          t.format 'edit-labels'
      if !templateModeEnabled
        t.a '.quick-card-editor-buttons-item.js-edit-members', { href: '#' }, ->
          t.icon 'member', { class: 'light' }
          t.span '.quick-card-editor-buttons-item-text', ->
            t.format 'change-members'
      t.a '.quick-card-editor-buttons-item.js-move-card', { href: '#' }, ->
        t.icon 'move', { class: 'light' }
        t.span '.quick-card-editor-buttons-item-text', ->
          t.format 'move'
      t.a '.quick-card-editor-buttons-item.js-copy-card', { href: '#' }, ->
        t.icon 'card', { class: 'light' }
        t.span '.quick-card-editor-buttons-item-text', ->
          t.format 'copy'
      if !isCardTemplate
        t.a '.quick-card-editor-buttons-item.js-edit-due-date', { href: '#' }, ->
          t.icon 'clock', { class: 'light' }
          t.span '.quick-card-editor-buttons-item-text', ->
            t.format 'change-due-date'
      t.mustacheBlockInverted 'closed', ->
        t.a '.quick-card-editor-buttons-item.js-archive', { href: '#' }, ->
          t.icon 'archive', { class: 'light' }
          t.span '.quick-card-editor-buttons-item-text', ->
            if isCardTemplate
              t.format 'hide-from-list'
            else
              t.format 'archive'

